// extracted by mini-css-extract-plugin
export default {"modal":"Oia-z","header":"Pia-z","fields":"Qia-z","error":"Ria-z","disabled":"Sia-z","reminderMsg":"Tia-z","errorMsg":"Uia-z","footer":"Via-z"};